export default {
  header: 'Nie udało się wczytać Twojego zamówienia',
  text: 'Coś poszło nie tak podczas przygotowywania zamówienia. Twój koszyk jest bezpieczny — spróbuj ponownie.',
  retry: 'Spróbuj ponownie',
  address_header: 'Potrzebujemy Twojego adresu dostawy',
  address_text: 'Nie możemy obliczyć sumy, dopóki nie znamy adresu dostawy. Twój koszyk jest bezpieczny.',
  address_action: 'Dodaj adres dostawy',
  back_checkout: 'Wróć do zamówienia',
  back_basket: 'Wróć do koszyka',
};
